import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/bitcoin.png'


const _hoisted_1 = { class: "border-0 rounded-3 mb-4 bg-primary bg-opacity-10 p-4" }
const _hoisted_2 = { style: {"margin":"auto","max-width":"325px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_0 + "\" class=\"rounded-circle\" style=\"width:48px;height:48px;\" alt=\"bitcoin\"></div><div class=\"flex-grow-1 ms-2\"><span class=\"mb-1 d-block fw-medium text-secondary\"> BITCOIN <span class=\"text-body fw-normal\">(BTC)</span></span><div class=\"d-flex\"><h3 class=\"mb-0 fs-20 fw-semibold me-1\">$27,500</h3><i class=\"material-symbols-outlined fs-16 position-relative top-3 text-success\"> trending_up </i><span class=\"text-success\">+2.3%</span></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "area",
            height: "120",
            options: _ctx.bitcoinChart,
            series: _ctx.bitcoin
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center\"><div><span class=\"fs-12 fw-medium d-block mb-1\">Market Cap:</span><h4 class=\"fs-12 fw-semibold mb-0\">$520B</h4></div><div><span class=\"fs-12 fw-medium d-block mb-1\">Volume (24h):</span><h4 class=\"fs-12 fw-semibold mb-0\">$35B</h4></div></div>", 1))
  ]))
}